var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.sub_view == 'cheques')?_c('div',[_c('buscador'),_c('lista-cheques')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }